var _style, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProdPreviewPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "125px",
    height: "125px",
    viewBox: "0 0 125 125",
    style: {
      enableBackground: "new 0 0 125 125"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EAEDF0;}\n\t.st1{fill:none;stroke:#C5CCD3;stroke-width:1.8362;stroke-linecap:round;stroke-linejoin:round;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.2,
    y: -0.3,
    className: "st0",
    width: 125,
    height: 125
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.4,72.9h6.2c5.2,0,7.3-2.1,7.3-7.3v-6.2c0-5.2-2.1-7.3-7.3-7.3h-6.2c-5.2,0-7.3,2.1-7.3,7.3v6.2 C52.1,70.8,54.2,72.9,59.4,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.4,60.4c1.2,0,2.1-0.9,2.1-2.1c0-1.1-0.9-2.1-2.1-2.1c-1.2,0-2.1,0.9-2.1,2.1 C57.3,59.5,58.2,60.4,59.4,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,69.7l5.1-3.4c0.8-0.6,2-0.5,2.8,0.1l0.3,0.3c0.8,0.7,2.1,0.7,2.9,0l4.3-3.7c0.8-0.7,2.1-0.7,2.9,0 l1.7,1.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdPreviewPlaceholder);
export default __webpack_public_path__ + "static/media/prod-preview-placeholder.7034e42bff50768792df1f183bd4f7bb.svg";
export { ForwardRef as ReactComponent };